import styled from "styled-components"

export const FaucetWrapper = styled.div`
width: 100%;
max-width: 1400px;
padding: 2rem 3rem;
margin: 2rem auto;
position: relative;
z-index: 10;

@media screen and (max-width: 1024px) {
  max-width: 90%;
  padding: 2rem 1.5rem;
}

@media screen and (max-width: 768px) {
  max-width: 95%;
  padding: 1.5rem 1rem;
  margin: 1.5rem auto;
}
`

export const Faucet = styled.div`
width: 100%;
padding: 3rem 2.5rem;
background: rgba(255, 255, 255, 0.05);
backdrop-filter: blur(20px);
-webkit-backdrop-filter: blur(20px);
color: #fff;
border-radius: 28px;
border: 1px solid rgba(255, 255, 255, 0.1);
box-shadow: 0px 20px 60px rgba(0, 0, 0, 0.3),
            inset 0px 1px 1px rgba(255, 255, 255, 0.1);
transition: all 0.4s ease;

&:hover {
  border-color: rgba(255, 255, 255, 0.2);
  box-shadow: 0px 25px 70px rgba(0, 0, 0, 0.4),
              inset 0px 1px 1px rgba(255, 255, 255, 0.2);
}

@media screen and (max-width: 768px) {
  padding: 2rem 1.5rem;
}

@media screen and (max-width: 480px) {
  padding: 1.5rem 1.2rem;
  border-radius: 20px;
}
`

export const BalanceView = styled.div`
width: 100%;
max-width: 95%;
font-family: Poppins;
font-size: 10rem;
line-height: 0.5;
color: #fff;
margin-top: 1rem;
margin-bottom: 1rem;
`

export const Input = styled.input`
background: rgba(255, 255, 255, 0.08);
backdrop-filter: blur(10px);
border: 1.5px solid rgba(255, 255, 255, 0.15);
border-radius: 16px;
box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
padding: 1.3rem 1.6rem;
transition: all 0.4s ease;
color: #fff;
min-height: 60px;
width: 100%;
outline: none;
font-size: 16px;
font-family: 'Poppins', sans-serif;
font-weight: 500;

&:focus {
    border-color: rgba(255, 255, 255, 0.4);
    background: rgba(255, 255, 255, 0.12);
    box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.05),
                0 12px 40px rgba(0, 0, 0, 0.3);
    transform: translateY(-2px);
  }

&::placeholder {
    color: rgba(255, 255, 255, 0.45);
    font-weight: 400;
  }

@media screen and (max-width: 480px) {
  padding: 1.1rem 1.3rem;
  font-size: 15px;
  min-height: 54px;
}
`

export const IntroLabel = styled.div`
font-family: Poppins;
font-size: 4em;
font-weight: 900;
background: linear-gradient(135deg, #fff 0%, #e0e0e0 50%, #b0b0b0 100%);
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;
background-clip: text;
margin-bottom: 0.3em;
text-align: center;
letter-spacing: -2px;
line-height: 1.1;
text-shadow: 0 0 60px rgba(255, 255, 255, 0.1);
animation: glow 3s ease-in-out infinite;

@keyframes glow {
  0%, 100% {
    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.15));
  }
  50% {
    filter: drop-shadow(0 0 30px rgba(255, 255, 255, 0.25));
  }
}

@media screen and (max-width: 1024px) {
  text-align: center;
  font-size: 3.5em;
}

@media screen and (max-width: 768px) {
  font-size: 2.8em;
}

@media screen and (max-width: 480px) {
  font-size: 2.2em;
  letter-spacing: -1px;
}
`

export const SubTitle = styled.p`
font-family: Poppins;
font-size: 1.15em;
font-weight: 400;
color: rgba(255, 255, 255, 0.65);
margin-bottom: 1em;
text-align: center;
letter-spacing: 0.3px;
line-height: 1.7;

@media screen and (max-width: 1024px) {
  text-align: center;
}

@media screen and (max-width: 768px) {
  font-size: 1em;
}

@media screen and (max-width: 480px) {
  font-size: 0.95em;
  margin-bottom: 1em;
  line-height: 1.6;
}
`

export const InputLabel = styled.label`
font-family: Poppins;
font-size: 0.75em;
font-weight: 600;
color: rgba(255, 255, 255, 0.9);
margin-bottom: 0.5em;
display: block;
text-transform: uppercase;
letter-spacing: 0.5px;
`

export const CaptionLabel = styled.p`
font-family: Poppins;
font-size: 1em;
color: rgba(255, 255, 255, 0.85);

`

export const BalanceLabel = styled.p`
font-family: Poppins;
font-size: 3rem;
line-height: 1.2;
color: rgba(255, 255, 255, 0.9);
margin-top: 0.5rem;
`

export const ButtonWrapper = styled.div`
width: 100%;
margin-top: 1.8em;
display: flex;
justify-content: center;
`

export const DepositButton = styled.button`
padding: 1.4rem 3.5rem;
border-radius: 18px;
border: none;
background: linear-gradient(135deg, #2a2a2a 0%, #333333 50%, #444444 100%);
color: #fff;
font-size: 1.15em;
font-weight: 700;
font-family: 'Poppins', sans-serif;
box-shadow: 0 0 30px rgba(255, 255, 255, 0.08),
            0 10px 30px rgba(0, 0, 0, 0.5);
cursor: pointer;
transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
letter-spacing: 0.5px;
position: relative;
overflow: hidden;
width: 100%;
display: flex;
align-items: center;
justify-content: center;
gap: 0.5rem;

&::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s;
}

&:hover{
    background: linear-gradient(135deg, #333333 0%, #444444 50%, #555555 100%);
    transform: translateY(-3px) scale(1.01);
    box-shadow: 0 0 40px rgba(255, 255, 255, 0.12),
                0 15px 40px rgba(0, 0, 0, 0.5);
}

&:hover::before {
  left: 100%;
}

&:active {
    transform: translateY(-1px) scale(0.99);
}

@media screen and (max-width: 768px) {
  padding: 1.2rem 2.8rem;
  font-size: 1.05em;
}

@media screen and (max-width: 480px) {
  padding: 1.2rem 2rem;
  font-size: 1em;
  width: 100%;
}
`

export const WithdrawButton = styled.button`
padding: 1.3rem 3.5rem;
border-radius: 16px;
border: none;
background: linear-gradient(135deg, #2a2a2a 0%, #333333 50%, #444444 100%);
color: #fff;
box-shadow: 0 0 30px rgba(255, 255, 255, 0.08),
            0 10px 30px rgba(0, 0, 0, 0.5);
cursor: pointer;
font-size: 1.1em;
font-weight: 700;
font-family: 'Poppins', sans-serif;
transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
letter-spacing: 0.5px;

&:hover{
    background: linear-gradient(135deg, #333333 0%, #444444 50%, #555555 100%);
    transform: translateY(-3px) scale(1.02);
    box-shadow: 0 0 40px rgba(255, 255, 255, 0.12),
                0 15px 40px rgba(0, 0, 0, 0.5);
}

&:active {
    transform: translateY(-1px) scale(1);
}
`

export const CurrentAddress = styled.p`
font-family: Poppins;
font-size: 1rem;
color: rgba(255, 255, 255, 0.8);
`
export const ConnectButton = styled.button`
  padding: 1rem 2rem;
  margin-right: 2rem;
  border-radius: 14px;
  align-self: center;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.06);
  backdrop-filter: blur(10px);
  color: #fff;
  font-weight: 700;
  font-family: 'Poppins', sans-serif;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  cursor: pointer;
  transition: all 0.3s ease;
  letter-spacing: 0.5px;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.3);
    transform: translateY(-2px);
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4);
  }

  &:active {
    transform: translateY(0px);
  }

  @media screen and (max-width: 768px) {
    padding: 0.9rem 1.5rem;
    font-size: 0.95em;
    margin-right: 1rem;
  }
`;

export const InfoGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;

  @media screen and (max-width: 1024px) {
    flex-direction: row;
    gap: 1rem;
  }

  @media screen and (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
  }
`;

export const InfoCard = styled.div`
  background: rgba(255, 255, 255, 0.04);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  padding: 1.5rem 1.8rem;
  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.2),
              inset 0px 1px 1px rgba(255, 255, 255, 0.08);
  text-align: center;
  transition: all 0.4s ease;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 4px;
    background: linear-gradient(180deg, #ffffff, #b0b0b0, #888888);
    transform: scaleY(0);
    transform-origin: bottom;
    transition: transform 0.4s ease;
  }

  &:hover {
    transform: translateY(-5px);
    border-color: rgba(255, 255, 255, 0.15);
    background: rgba(255, 255, 255, 0.06);
    box-shadow: 0px 12px 40px rgba(0, 0, 0, 0.3),
                inset 0px 1px 1px rgba(255, 255, 255, 0.15);
  }

  &:hover::before {
    transform: scaleY(1);
    transform-origin: top;
  }

  @media screen and (max-width: 1024px) {
    text-align: center;
    
    &:hover {
      transform: translateY(-5px);
    }
  }

  @media screen and (max-width: 768px) {
    padding: 1.3rem 1.5rem;
  }

  @media screen and (max-width: 480px) {
    padding: 1.2rem 1.2rem;
  }
`;

export const InfoTitle = styled.h3`
  font-family: 'Poppins', sans-serif;
  font-size: 1.2em;
  font-weight: 700;
  color: #fff;
  margin-bottom: 0.6rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  @media screen and (max-width: 1024px) {
    justify-content: center;
  }

  @media screen and (max-width: 768px) {
    font-size: 1.1em;
  }

  @media screen and (max-width: 480px) {
    font-size: 1.05em;
  }
`;

export const InfoText = styled.p`
  font-family: 'Poppins', sans-serif;
  font-size: 0.93em;
  color: rgba(255, 255, 255, 0.65);
  line-height: 1.6;
  margin: 0;

  @media screen and (max-width: 480px) {
    font-size: 0.88em;
  }
`;